export default __webpack_public_path__ + "static/hero-6b8383c982ea706e1fe79998b37f6fa0.png";